<template>
    <div class="h-screen flex justify-center items-center text-gray-900">
        <div class="w-full max-w-md mx-auto p-4">

            <h1 class="text-2xl mb-8">Login</h1>

            <form class="space-y-6" @submit.prevent="onSubmit">

                <InputBasic
                    label="Email"
                    name="email"
                    placeholder="Please enter your email..."
                    type="email"/>

                <InputBasic
                    label="Password"
                    name="password"
                    placeholder="Please enter your password..."
                    type="password"/>

                <SubmitButton
                    :class="{'hover:bg-blue-100 hover:text-blue-700 active:text-blue-900': !form.errors.any()}"
                    :disabled="form.errors.any()"
                    :submitting="form.processing"
                    class="w-full text-blue-600 text-sm py-2 px-4 border border-blue-500 rounded">
                    Login
                </SubmitButton>
            </form>

            <inertia-link class="inline-block text-primary mt-6" href="/password/reset">
                Forgotten your password?
            </inertia-link>
        </div>
    </div>
</template>

<script>

import Form from "form-backend-validation"
import InputBasic from "@app/Shared/Components/InputBasic";
import SubmitButton from "@app/Shared/Components/SubmitButton";

export default {

    data() {
        return {
            form: new Form({
                email: '',
                password: ''
            }, {resetOnSuccess: false})
        }
    },

    components: {
        InputBasic,
        SubmitButton
    },

    methods: {
        onSubmit() {

            if (this.form.processing) {
                return;
            }

            this.form.post('/login')
                .then(response => {
                    window.location.href = "/admin";
                })
                .catch()
        }
    },

    watch: {
        'form.password'() {
            this.form.errors.clear('email');
        }
    }
};
</script>
